import { useCallback, useRef } from "react";

export const useLongPress = (onLongPress: (e: any) => any, delay: number, moveThreshold = 10) => {
  const timeout = useRef<NodeJS.Timeout | null>(null);
  const startX = useRef(0);
  const startY = useRef(0);

  const start = useCallback(
    (event: any) => {
      const touch = event.touches?.[0] || event;
      startX.current = touch.clientX;
      startY.current = touch.clientY;

      timeout.current = setTimeout(() => {
        onLongPress(event);
      }, delay);
    },
    [onLongPress, delay],
  );

  const move = useCallback(
    (event: any) => {
      const touch = event.touches?.[0] || event;
      const deltaX = Math.abs(touch.clientX - startX.current);
      const deltaY = Math.abs(touch.clientY - startY.current);

      if (deltaX > moveThreshold || deltaY > moveThreshold) {
        clear();
      }
    },
    [moveThreshold],
  );

  const clear = useCallback(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }, []);

  return {
    onMouseDown: start,
    onTouchStart: start,
    onMouseMove: move,
    onTouchMove: move,
    onMouseUp: clear,
    onMouseLeave: clear,
    onTouchEnd: clear,
  };
};
